export default {
    Statistics: 'Statistika',
    WeeklySales: 'Həftəlik Satışlar',
    Distribution: 'Distribusiya',
    Adobe: 'Adobe',
    Quarter: 'Rüb',
    Products: 'Məhsullar',
    Orders: 'Sifarişlər',
    Events: 'Tədbirlər',
    News: 'Xəbərlər',
    Library: 'Kitabxana',
    Settings: 'Parametrlər',
    Countries: 'Ölkələr',
    Users: 'İstifadəçilər',
    Categories: 'Kateqoriyalar',
    Prizes: 'Mükafatlar',
    WonPrizes: 'Qazanılan Mükafatlar',
    Markup: 'Əlavə Dəyər',
    MarkupGroup: 'Əlavə Dəyər Qrupu',
    Targets: 'Hədəflər',
    Groups: 'Qruplar',
    groups: 'Qrup',
    View: 'Baxış',

    royalty: 'Royalty',
    dealerPrice: 'Diller qiyməti',
    id: 'ID',
    title: 'Ad',
    action: 'Fəaliyyət',
    edit: 'Redaktə',
    delete: 'Silin',
    parent: 'Ana Kateqoriya',
    save: 'Yadda Saxla',
    add: 'Əlavə Etmək',
    PriceDetails: 'Qiymət haqqında detallar',
    total: 'Ümumi',
    NotEnoughMoney: 'Sifarişi yerləşdirmək mümkün deyil.<br>Sifarişin dəyəri kredit limitinin qalığından daha böyükdür.',
    PLACEORDER: 'MƏHSULU SİFARİŞ EDİN',
    BrowseProducts: 'Məhsullara nəzər salın',
    ExportToExcel: 'Excel-ə yükləyin',
    image: 'Şəkil',
    startAt: 'Başlanğıc tarixi',
    endAt: 'Bitmə tarixi',
    createdAt: 'Yaradılma tarixi',
    start: 'Başlanğıc',
    end: 'Son',
    description: 'Xarakteristika',
    products: 'Məhsullar',
    prizes: 'Mükafatlar',
    confirm: 'Təsdiq',
    doYouWantToDelete: 'Silmək istəyirsiniz',
    view: 'Baxın',
    more: 'Ətraflı',
    points: 'Xallar',
    RecoverYourPassword: 'Şifrənizi bərpa edin',
    RecoverYourPasswordDesc: 'Zəhmət olmasa elektron ünvanınızı daxil edin və şifrənizi necə bərpa etməyiniz barədə təlimat göndərəcəyik.',
    BackToLogin: 'Login-ə qayıdış',
    password: 'Şifrə',
    ConfirmPassword: 'Şifrəni təsdiqləyin',
    RecoverPassword: 'Şifrəni bərpa edin',
    ChangePassword: 'Şifrəni dəyişdirin',
    ChangeInformation: 'Məlumatı dəyişdirin',
    MyPrizes: 'Mükafatlarım',
    users: 'İstifadəçilər',
    file: 'Fayl',
    OldFile: 'Köhnə Fayl',
    download: 'Yükləyin',
    login: 'Login',
    loginDesc: 'Xoş gəlmişsiniz, zəhmət olmasa hesabınıza daxil olun.',
    RememberMe: 'Yadda Saxla',
    ForgotPassword: 'Şifrəni Unutmusuz?',
    SubTitle: 'Sub Title',
    status: 'Status',
    date: 'Tarix',
    viewAll: 'Bütün',
    fromDate: 'Tarixindən',
    toDate: 'Tarixinədək',
    searchById: 'Id-yə uyğun axtarış',
    searchBySku: 'SKU-ya uyğun axtarış',
    searchByProductName: 'Məhsul adına görə axtarış',
    productName: 'Məhsulun adı',
    userGroup: 'İstifadəçi Qrupu',
    sku: 'SKU',
    quantity: 'Miqdar',
    quantity_short: 'Miqdar',
    UnitPrice: 'Vahid Qiymət',
    price: 'Qiymət',
    ProductName: 'Məhsulun Adı',
    keys: 'Açar',
    TotalPrice: 'Ümumi Qiymət',
    comment: 'Şərh',
    comments: 'Şərhlər',
    DealerName: 'Diler',
    UserName: 'İstifadəçi Adı',
    InStock: 'Mövcud say',
    NotInStock: 'Mövcud deyil',
    NotEnoughPoint: 'Kifayət Qədər Xal Yoxdur',
    TakeAPrize: 'Mükafatı Əldə Edin',
    count: 'Kəmiyyət',
    point: 'Xal',
    category: 'Kateqoriya',
    amount: 'Qiymət',
    about: 'Şəxsi məlumat',
    CompanyName: 'Şirkətin Adı',
    voen: 'VÖEN',
    contract_number: 'Müqavilə nömrəsi',
    contract_start_at: 'Müqavilə tarixi',
    MPNID: 'MPN ID',
    name: 'Ad',
    emailAddress: 'Elektron ünvan',
    phone: 'Telefon',
    FinCode: 'Fin Kod',
    country: 'Ölkə',
    joined: 'Qoşulma tarixi',
    OldPassword: 'Köhnə Şifrə',
    NewPassword: 'Yeni Şifrə',
    ConfirmNewPassword: 'Yeni Şifrəni Təsdiqləyin',
    change: 'Dəyişin',
    Months: 'Aylar',
    Sum: 'Cəm',
    TargetProgress: 'Hədəfin Proqressi',
    toComplete: 'tamamlanıb',
    BestSeller: 'Ən yaxşı satılan',
    Top5Products: 'Top 5 Məhsul',
    targetDesc: 'Hədəfinizi əlavə etdikdən sonra, siz onu silib və ya dəyişdirə bilməzsiz.',
    limit: 'Limit',
    spent: 'Xərclənən',
    bonus: 'Bonus',
    photo: 'Foto',
    event: 'Tədbir',
    prize: 'Mükafat',
    unlimited: 'Limitsiz etmək?',
    ExportasCSV: 'CSV olaraq yükləyin',
    ConfirmTaken: 'Qəbul Edildiyini Təsdiqləyin',
    Taken: 'Qəbul olunub',
    PartnerStatus: 'Tərəfdaş Statusu',
    RemainingCreditLimit: 'Qalan Kredit Limiti',
    items: 'Məhsullar',
    InYourCart: 'Səbətinizdə',
    checkout: 'Sifarişinizi rəsmiləşdirin',
    YourCartIsEmpty: 'Səbətiniz boşdur.',
    profile: 'Profil',
    logout: 'Çıxış',
    activate: 'Aktivləşdir',
    return: 'Qaytar',
    sendByEmail: 'Email ilə göndər',
    sendAllActivatedByEmail: 'Bütün aktiv açarları email ilə göndərin',
    SendToken: 'Tokeni göndər',
    note: 'Qeyd',
    returnable: 'Bu məhsulu geri qaytarmaq mümkündür. Dahə ətraflı təlimatda',
    not_returnable: 'Bu məhsul geri qaytarılmır!',
    addToCart: 'Səbətə əlavə et',
    remove: 'Sil',
    group: 'Grup',
    user: 'İstifadəçi',
    paid: 'Paid',
    paidHistory: 'Paid History',
    soldBy: 'Satılıb',
    Brands: 'Brendlər',
    Clear: 'Sıfırla',
    language: 'Dillər',
    delivery_time: 'Çatdırılma müddəti',
    operating_systems: 'Əməliyyat sistemləri',
    license_type: 'Lisenziyanın növü',
    users_count: 'İstifadəçilərin sayı',
    devices_count: 'Cihazların sayı',
    tab_description: 'Təsvir',
    tab_requirement: 'Sistem Tələbləri',
    tab_installation: 'Quraşdırma',
    login_esd_desc: '<b>Techpro DC ESD portalı</b><br>Proqram təminatı üzrə elektron distribusiya portalı 24/7 istənilən vaxt onlayn rejimdə proqram təminatı üçün sifarişləri yerləşdirməyə imkan verəcəkdir. Sifariş verilən andan 3 dəqiqəyə qədər açarların çatdırılma müddətidir.<br><br><br>Yeni istifadəçilər - "Tərəfdaş ol" düyməsini tıklayın',
    login_about: 'Haqqımızda',
    BecomePartner: 'Tərəfdaş ol',
    ResetPassword: 'Şifrəni sıfırlama',
    PleaseEnterYourNewPassword: 'Zəhmət olmasa yeni şifrənizi daxil edin',
    FillTheBelowFormToBecomeAPartner: 'Tərəfdaş olmaq üçün aşağıdakı formanı doldurun',
    NameLastname: 'Ad soyad',
    Position: 'Vəzifə',
    ContactNumber: 'Əlaqə nömrəsi',
    CompanyVOEN: 'Şirkətin VOEN\'i',
    term: '<a href="https://esd.techprodc.com/storage/81/muqavile_esd.az.pdf" target="_blank">Şərtləri</a> qəbul edirəm.',
    excelText1: 'Portalda olan bütün qiymətlər ABŞ dolları ilə göstərilir. Ödəmə vaxtı ödəniş Pasha Bank-ın ABŞ dolları kursuna uyğun manatla həyata keçirilir.',
    excelText2: 'Portalda göstərilən qiymətlərə ƏDV daxil deyildir.',
    dealerPriceText: 'Diller qiymətinə ƏDV daxil deyildir.',
    need_azn_cash: 'AZN-lə nağd ödəməyə ehtiyac var?',
    need_azn_credit: 'AZN-lə kreditlə ödəməyə ehtiyac var?',
    cash: 'Nağd',
    credit: 'Kredit',
    net_tovara_v_korzine: 'Səbətinizdə heç bir məhsul yoxdur',
    activateAllKeys: 'Bütün açarları aktivləşdir',
    need_create_adobe_account: 'Adobe hesabı yaratmaq?',
    region: 'Region',
    city: 'City',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    postalCode: 'Postal Code',
    marketSegments: 'Market Segments',
    marketSegment: 'Market Segment',
    has_adobe_account: 'Adobe hesabı',
    search: 'Axtar',
    makeAnOrder: 'Sifariş verin',
    full_name: 'Ad Soyad',
    AdobeCustomer: 'Adobe müştərisi',
    orderType: 'Sifariş növü',
    getPrice: 'Qiymət al',
    pricePerOne: 'Qiymət bir üçün',
    totalPrice: 'Ümumi qiymət',
    in_progress: 'İşlənir',
    pending: 'Gözləyir',
    for_x_days: '{days} Gün',

};
